export default {
  cursado: { espacio: {}, carrera: {}, docentes: [] },
  cursados: [],
  fields: {},
  errorArray: [],
  dialog: false,
  pagination: {},
  ciclosLectivos: [],
};
